import { $t } from '../../composables/i18n'
import { Codebook } from '../Codebook'

export enum VatApplicationTimingId {
  PAID = 'paid',
  USED = 'used',
}

export class VatApplicationTiming extends Codebook<VatApplicationTimingId> {
  static readonly PAID = new VatApplicationTiming(VatApplicationTimingId.PAID, () => $t('Paid'))
  static readonly USED = new VatApplicationTiming(VatApplicationTimingId.USED, () =>
    $t('Used (order is realized)'),
  )

  private constructor(
    public readonly value: VatApplicationTimingId,
    public readonly label: () => string,
  ) {
    super(value)
  }
}
